<template>
    <div class="h-full">
        <Card class="h-full">
            <template #title>
                <div class="flex items-center gap-2">
                    <Icon
                        name="bolt"
                        class="min-w-4 min-h-4 w-4 h-4 text-gray-500"
                    />
                    <span class="truncate">
                        {{ automation.name }}
                    </span>
                    <AutomationStateBadge :state="automation.state.key" />
                </div>
            </template>
            <template #content>
                <div class="border-b border-b-gray-200 mb-4"></div>

                <div>
                    <div class="text-sm space-y-4">
                        <div class="">
                            <div
                                class="text-xs font-semibold text-gray-500 uppercase"
                            >
                                Trigger:
                            </div>
                            <div>
                                {{ automation.triggerType.label }}
                            </div>
                        </div>
                        <div class="">
                            <div
                                class="text-xs font-semibold text-gray-500 uppercase"
                            >
                                Action:
                            </div>
                            <div>
                                {{ automation.actionType.label }}
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template #actions>
                <div
                    class="flex flex-col lg:flex-row lg:justify-end w-full gap-1"
                >
                    <EnableDisableAutomationButton
                        :isEnabled="automation.isEnabled()"
                        :updateUrl="
                            urlFactory.makeAutomationUpdateStateUrl(
                                automation.id,
                            )
                        "
                        @onSuccess="handleAutomationUpdated($event.automation)"
                    >
                        {{ automation.isEnabled() ? 'Disable' : 'Enable' }}
                    </EnableDisableAutomationButton>
                    <Button
                        as="a"
                        :href="
                            urlFactory.makeAutomationEditPageUrl(automation.id)
                        "
                        color="light"
                        size="small"
                        iconName="edit"
                    >
                        Edit
                    </Button>
                    <DeleteAutomationButtonModal
                        v-if="isSuperAdmin"
                        :automation="automation"
                        @onSuccess="handleAutomationDeleted()"
                    />
                </div>
            </template>
        </Card>
    </div>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { type PropType } from 'vue'
    import Card from '@/Shared/Component/Card.vue'
    import Icon from '@/Shared/Component/Icon.vue'
    import Button from '@/Shared/Component/Button.vue'
    import Automation from '@/App/Automation/Entity/Automation'
    import DeleteAutomationButtonModal from '@/App/Automation/Component/DeleteAutomationButtonModal.vue'
    import EnableDisableAutomationButton from '@/App/Automation/Component/EnableDisableAutomationButton.vue'
    import AutomationStateBadge from '@/App/Automation/Component/AutomationStateBadge.vue'

    const emit = defineEmits<{
        onAutomationDeleted: []
        onAutomationUpdated: [{ automation: Automation }]
    }>()

    const props = defineProps({
        automation: {
            type: Object as PropType<Automation>,
            required: true,
        },
        isSuperAdmin: {
            type: Boolean,
            required: true,
        },
    })

    const handleAutomationDeleted = () => {
        emit('onAutomationDeleted')
    }

    const handleAutomationUpdated = (automation: Automation) => {
        emit('onAutomationUpdated', {
            automation: automation,
        })
    }
    const urlFactory = new UrlFactory()
</script>
